import styled, { css } from 'styled-components';
import { BREAKPOINTS } from 'foundations-components/transitional/components/Grid';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const toPx = value => typeof value === 'number' ? `${value}px` : value;
const CarouselWrapper = styled.section.withConfig({
  displayName: "SingleStepContent__CarouselWrapper",
  componentId: "sc-1xl5aat-0"
})(["display:flex;flex-direction:column;align-items:center;padding:", ";position:relative;"], ({
  theme
}) => theme.space['500']);
const CarouselCallout = styled.aside.withConfig({
  displayName: "SingleStepContent__CarouselCallout",
  componentId: "sc-1xl5aat-1"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return css(["margin-top:", ";margin-left:", ";margin-right:", ";text-align:center;@media only screen and (max-width:", "){margin-top:", ";padding-left:", ";}"], theme.space['500'], theme.space['1200'], theme.space['1200'], BREAKPOINTS.sm, theme.space['500'], theme.space['0']);
});

// Inspired from UIComponents/carousel/UICarousel
const SingleStepContent = ({
  step
}) => {
  return (
    /*#__PURE__*/
    //@bend-expect trellis-tokenized
    _jsxs(CarouselWrapper, {
      "data-test-id": "coaching-tip-popover-single-step",
      "aria-atomic": true,
      "aria-live": "off",
      tabIndex: 0,
      children: [/*#__PURE__*/_jsx("main", {
        children: step.content
      }), step.description &&
      /*#__PURE__*/
      // @bend-expect trellis-tokenized
      _jsx(CarouselCallout, {
        children: step.description
      })]
    })
  );
};
export default SingleStepContent;